import { Countdown } from "./CountDown";
import { CustomDropDown } from "./CustomDropDown";
import { CustomPagination } from "./CustomPagination";
import { PageResult } from "./PageResult";
import { ProductCard } from "./ProductCard";
import { SliderVerification } from "./SliderVerification";
import { Numeric } from "./Numeric";
import { CustomUpload } from "./CustomUpload";
import { CustomSteps } from "./CustomSteps";
import { PayCard } from "./PayCard";
import { ImageCard } from "./ImageCard";

export {
  Countdown,
  CustomPagination,
  PageResult,
  ProductCard,
  SliderVerification,
  CustomDropDown as CusDropDown,
  Numeric,
  CustomUpload,
  CustomSteps,
  PayCard,
  ImageCard
};
